
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import Navbar from './NavBar';

const MainLayout = () => {
  return (
    <Box 
      data-testid="main-layout" 
      sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        height: '100vh',
        width: '100%',
        maxWidth: '100%',
        overflow: 'hidden'
      }}
    >
      <Navbar />
      <Box 
        component="main" 
        sx={{ 
          flexGrow: 1, 
          overflow: 'hidden',
          width: '100%',
          maxWidth: '100%'
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default MainLayout;
